import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { useTheme } from '@mui/material/styles';
import { GradientBorder } from '../gradients/GradientBorder';
import { useDateFormatter } from 'src/hooks/useDateFormatter';

export interface MintDatePanelProps {
  startDate: Date;
  endDate: Date | undefined;
}

const DATE_FORMAT: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: undefined,
};

export function MintDatePanel({ startDate, endDate }: MintDatePanelProps) {
  const theme = useTheme();
  const format = useDateFormatter({
    dateFormat: DATE_FORMAT,
    separator: ' at ',
  });
  const startDateFormatted = startDate ? format(startDate) : undefined;
  const endDateFormatted = endDate ? format(endDate) : undefined;
  return (
    <GradientBorder
      borderRadius="10px"
      sx={{
        borderWidth: '1px',
        boxShadow: theme.shadows[2],
        '&:hover': {
          boxShadow: theme.shadows[4],
        },
      }}
    >
      <Stack
        gap="4px"
        direction="column"
        alignItems="stretch"
        justifyContent="center"
        textAlign="left"
        sx={{
          paddingX: '24px',
          paddingY: '12px',
        }}
      >
        <GradientTypography
          gradientColor="primary.vertical"
          variant="h5"
          sx={{ textTransform: 'uppercase' }}
        >
          Mint Date
        </GradientTypography>
        <Typography variant="subtitle1">
          {startDate && `${!endDate ? 'Started on ' : ''}${startDateFormatted}`}
          {endDate && ` - ${endDateFormatted}`}
        </Typography>
      </Stack>
    </GradientBorder>
  );
}
